module.exports = __webpack_public_path__ + "img/ic.8deb6a55.png";